import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MdOutlineMail } from "react-icons/md";
import "../../Styles/Login.css";
import Logo from "../../assets/images/logo.png";
import { useState } from "react";
import LoadingSpinner from "../../Components/spinner";
import { forgotPassword } from "../../services/axios/apiManager";
import { toast } from "sonner";

export default function VerifyEmailAddress() {
  const [searchParams] = useSearchParams();
  const isRedirect = searchParams.get("redirect");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const validateEmail = () => {
    if (!email.trim()) {
      setEmailError("Email is required");
      return false;
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      setEmailError("Please enter a valid email");
      return false;
    } else {
      setEmailError("");
      return true;
    }
  };

  const handleVerfiyEmail = async (e) => {
    e.preventDefault();
    if (!validateEmail()) return;
    if (loading) return;
    setLoading(true);
    const res = await forgotPassword({
      email: email,
      redirect: isRedirect || false,
    });
    if (res?.data?.success) {
      toast.success(
        "Password reset link has been sent to you email address, use the link to reset your password",
        { duration: 10000 }
      );
      navigate(-1);
    } else {
      toast.error(
        res?.data?.message || "Something went wrong, please try again later",
        { duration: 3000 }
      );
    }
    setLoading(false);
  };

  return (
    <main className="nftg-content-two" style={{ backgroundColor: "#0b0f14" }}>
      <section className="authentication pt-120 pb-120 fade-wrapper">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="authentication__wrapper text-center">
                <img src={Logo} style={{ margin: "0 auto", width: "120px" }} />
                <div className="mb-55">
                  <h2
                    className="title-lg fw-8 stroked-text transform-none title-animation"
                    style={{ color: "white", fontWeight: "700" }}
                  >
                    Forgot password
                  </h2>
                  <p
                    className="text-xl text-alter"
                    style={{ color: "gray", fontWeight: "400" }}
                  >
                    Please enter the email address associated with your account.
                    We will verify it and send a password reset link to that
                    address.
                  </p>
                </div>
                <div className="authentication__inner">
                  <div className="custom-tab">
                    <form onSubmit={handleVerfiyEmail}>
                      <div className="input-single">
                        <label htmlFor="userEmail">Your Email</label>
                        <div className="ic-group">
                          <input
                            type="text"
                            id="userEmail"
                            placeholder="Enter Email"
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          <MdOutlineMail />
                        </div>
                        {emailError && emailError.length && (
                          <span className="text-danger">{emailError}</span>
                        )}
                      </div>
                      <div className="btn-wrapper">
                        <button
                          className="btn--secondary"
                          data-testid="submit-button"
                          type="submit"
                          aria-label="login"
                          title="login"
                        >
                          {loading ? <LoadingSpinner size="lg" /> : "Submit"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
